// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"0d60d5e3","361":"36c1bd23","951":"9b00a296"}[chunkId] + ".chunk.js";
};